module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead3-ff5e860d045ed964ccfa219bf0bf2869.jpg";